<template lang="pug">
div
    v-card.transparent
        v-card-text
            v-banner(two-line).success
                v-avatar(slot="icon" color="white" size=40)
                    v-icon(color="green") fas fa-upload
                | Opcionalmente puede subir su archivo .dec generado vía software <a href="http://www.impuestosbolivia.net/form4/facilito.php" target="blank" style="color:#FFF">Facilito</a>, y así ya no presentar un cd físico.
        v-card-text
            v-form(v-model="validateUploadForm")
                v-layout(row wrap)
                    v-flex(xs12).text-center.pt-1
                        h3 Llene el siguiente formulario<br>para subir su archivo .dec
                    v-flex(xs12)
                        v-text-field(
                            label="CI (Numero de documento):"
                            outlined
                            v-mask="'cccccccccccc'"
                            :rules="$rules.ci"
                            v-model="dataUploadDec.ci"
                            autocomplete="off"
                            ref="refsUploadDecCi"
                            :hide-details="refsUploadDec.ci"
                            @update:error="refsUploadDec.ci = $refs.refsUploadDecCi.valid"
                            @blur="refsUploadDec.ci = $refs.refsUploadDecCi.valid"
                            @keydown="refsUploadDec.ci = $refs.refsUploadDecCi.valid")
                    v-flex(xs6)
                        v-select(
                            :items="$dic.meses"
                            outlined
                            label="Periodo (Mes):"
                            v-model="dataUploadDec.mes"
                            hide-details)
                    v-flex(xs6)
                        v-select(
                            :items="$timer.getYears(1970,2019)"
                            outlined
                            label="Periodo (Año):"
                            v-model="dataUploadDec.anio"
                            hide-details)
                    v-flex(xs12)
                        v-file-input(
                            label="ARCHIVO .DEC"
                            placeholder="Seleccionar..."
                            show-size
                            accept=".dec"
                            v-model="dataUploadDec.dec"
                            outlined
                            hide-details)
        v-card-actions
            v-spacer
            v-btn.success.txtn(large :loading="isLoading" @click="subirArchivoDec") Subir archivo&nbsp;
                v-icon fas fa-file-upload
            v-spacer
        v-card-text
            h4.font-weight-normal(style="line-height:15px") * Una vez subido el archivo, podrá indicar al técnico recepcionista que está presentado su archivo (.dec)  vía web en vez del CD.
    v-card.transparent.mt-5
        v-card-text
            | Puede verficar sus archivos subidos ingresando su CI:
        v-card-text.pt-1
            v-text-field(label="CI (Numero de documento):" outlined hide-details v-mask="'cccccccccccc'")
                template(v-slot:append-outer)
                    v-btn(color="success" @click="dialogUltimosDec=true" style="margin-top:-5px").txtn Verificar
    v-dialog(v-model="dialogConfirm" width=400)
        v-card
            v-toolbar(dark color="success" dense).no-padding.no-margin
                v-toolbar-title Archivo subido.
                v-spacer
                v-btn(icon dark @click="dialogConfirm = false")
                    v-icon fas fa-times
            v-card-text.text-center.pb-5
                h3.pt-3 Su archivo fué subido correctamente al servidor, puede verificarlo mas adelante con su ci:
                h3.pt-2 4687156
                v-btn(color="success" @click="dialogConfirm = false").mt-2 Aceptar
</template>
<script>
export default {
    data() {
        return {
            dataUploadDec: {
                ci: null,
                mes: null,
                anio: null,
                dec: null
            },
            dialogConfirm: false,
            isLoading: false,
            validateUploadForm: false,
            refsUploadDec: {
                ci: true,
                dec: true
            }
        }
    },
    computed: {
        //
    },
    mounted() {
        //this.ciDetails = true
    },
    methods: {
        async subirArchivoDec(){
            try{
                // Check form validation
                // check captcha
                // init progress in button
                let response = await axios({
                    method: 'post',

                })
                // stop progress in button
                console.log('Data', this.dataUploadDec)
            }
            catch(e){
                this.$snotify.info('Error catch')
                // stop progress in button
            }
        }
    }
}
</script>